import { render, staticRenderFns } from "./address info.vue?vue&type=template&id=931d6452"
import script from "./address info.vue?vue&type=script&lang=js"
export * from "./address info.vue?vue&type=script&lang=js"
import style0 from "./address info.vue?vue&type=style&index=0&id=931d6452&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports